import { assertEnv } from "@homeinstead/shared";

export const apiVersion =
  process.env.NEXT_PUBLIC_SANITY_API_VERSION || "2026-03-04";

export const dataset = assertEnv(
  "NEXT_PUBLIC_SANITY_DATASET",
  process.env.NEXT_PUBLIC_SANITY_DATASET,
);

export const projectId = assertEnv(
  "NEXT_PUBLIC_SANITY_PROJECT_ID",
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
);

export const studioUrl = assertEnv(
  "NEXT_PUBLIC_SANITY_STUDIO_URL",
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview" &&
    process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL
    ? `https://${process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL.replace("hi-www", "hi-studio")}`
    : process.env.NEXT_PUBLIC_SANITY_STUDIO_URL,
);
